import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-my-forecast',
  templateUrl: './my-forecast.component.html',
  styleUrls: ['./my-forecast.component.scss']
})
export class MyForecastComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/client/my-forecast/my-forecast.component.ts